import type { ReactNode } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import styles from "./SectionDescription.module.scss";

export interface SectionDescriptionProps {
  children: ReactNode;
  className?: string;
}

export const SectionDescription = ({
  children,
  className,
}: SectionDescriptionProps) => {
  const [block] = useModuleBEM(styles, "SectionDescription");

  return <div className={clsx(block, className)}>{children}</div>;
};
